import type { DialogProps } from './Dialog'
import { Dialog } from './Dialog'

export type SheetProps = Omit<DialogProps, 'position'>

export function Sheet(props: SheetProps) {
  return <Dialog {...props} position="right" />
}
